import React from "react";
import "./Logo.css";
import colors from "../theme/colors";

const Logo = ({ variant = "default", className = "", textColor = "dark", navBrand = false }) => {
  const textFill = navBrand ? colors.accentCyan : colors.textPrimary;
  const taglineFill = colors.textMuted;
  const isIconOnly = variant === "icon-only";
  const iconStroke = textColor === "white" ? colors.textPrimary : colors.textPrimary;

  const gradStart = colors.accentBlue;
  const gradEnd = colors.accentCyan;

  return (
    <div className={`logo-container ${variant} ${className} ${textColor === "white" ? "logo-white" : ""}`}>
      {isIconOnly ? (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="logo-svg">
          <defs>
            <linearGradient id="primeNetworkGradientIconOnly" x1="16" y1="12" x2="62" y2="66" gradientUnits="userSpaceOnUse">
              <stop stopColor={gradStart} />
              <stop offset="1" stopColor={gradEnd} />
            </linearGradient>
          </defs>
          <rect x="8" y="8" width="64" height="64" rx="18" fill="url(#primeNetworkGradientIconOnly)" />
          <circle cx="25" cy="24" r="4.5" fill={iconStroke} />
          <circle cx="56" cy="24" r="4.5" fill={iconStroke} />
          <circle cx="56" cy="56" r="4.5" fill={iconStroke} />
          <path d="M25 24V56H43" stroke={iconStroke} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M43 56L56 56" stroke={iconStroke} strokeWidth="6" strokeLinecap="round" />
          <path d="M25 24H56" stroke={iconStroke} strokeWidth="3" strokeLinecap="round" opacity="0.8" />
          <path d="M56 24V56" stroke={iconStroke} strokeWidth="3" strokeLinecap="round" opacity="0.8" />
        </svg>
      ) : (
        <svg
          width="360"
          height="80"
          viewBox="0 0 360 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="logo-svg"
        >
          <defs>
            <linearGradient id="primeNetworkGradient" x1="10" y1="8" x2="64" y2="70" gradientUnits="userSpaceOnUse">
              <stop stopColor={gradStart} />
              <stop offset="1" stopColor={gradEnd} />
            </linearGradient>
          </defs>

          <g className="logo-icon">
            <rect x="8" y="8" width="64" height="64" rx="18" fill="url(#primeNetworkGradient)" />
            <circle cx="25" cy="24" r="4.5" fill={iconStroke} />
            <circle cx="56" cy="24" r="4.5" fill={iconStroke} />
            <circle cx="56" cy="56" r="4.5" fill={iconStroke} />
            <path d="M25 24V56H43" stroke={iconStroke} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M43 56L56 56" stroke={iconStroke} strokeWidth="6" strokeLinecap="round" />
            <path d="M25 24H56" stroke={iconStroke} strokeWidth="3" strokeLinecap="round" opacity="0.8" />
            <path d="M56 24V56" stroke={iconStroke} strokeWidth="3" strokeLinecap="round" opacity="0.8" />
          </g>

          <text
            x="88"
            y="39"
            fontSize="30"
            fontWeight="700"
            fill={textFill}
            fontFamily="'Space Grotesk', sans-serif"
            className="logo-text"
            letterSpacing="-0.4"
          >
            Prime Network
          </text>
          <text
            x="88"
            y="58"
            fontSize="11"
            fontWeight="500"
            fill={taglineFill}
            fontFamily="'DM Sans', sans-serif"
            className="logo-tagline"
            letterSpacing="0.55"
          >
            PREMIUM INFRASTRUCTURE AND CONNECTIVITY
          </text>
        </svg>
      )}
    </div>
  );
};

export default Logo;
